export default __webpack_public_path__ + "static/media/city.a2b08b36.svg";